import { Component, OnInit } from '@angular/core';
import { ChildDataTableDirective } from '../../../shared/directives/child-data-table.directive';
import { InvoiceItem } from '../models/invoice-item.model';
import { ColumnConfig } from '../../../shared/models/column-config.model';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { PageStateManagerService } from '../../../shared/services/page-state-manager.service';
import { TitleService } from '../../../shared/services/title.service';
import { InvoiceService } from '../invoice.service';
import { InvoiceItemService } from '../invoice-item.service';
import { Observable, combineLatest, switchMap, EMPTY } from 'rxjs';
import { ResultSet } from '../../../shared/models/result-set.model';
import { MemberPlot } from '../../member-plots/models/member-plot.model';

@Component({
  selector: 'app-invoice-items-list',
  standalone: false,
  templateUrl: '../../../shared/templates/child-data-table.component.html',  
  styleUrls: ['./invoice-items-list.component.scss'],
  
})
export class InvoiceItemsListComponent extends ChildDataTableDirective<InvoiceItem> implements OnInit {
  override onGoBack(): void {
    // Navigate back to the previous page or a default route
    if (this.router) {
      this.router.navigate(['../../'], { relativeTo: this.route });
    } else {
      console.warn('Router is not available to navigate back.');
    }
  }
  override columns: ColumnConfig[] = [];   
  override modelName = 'Invoice Item';  

  constructor(
    private invoiceItemService: InvoiceItemService, 
    fb: FormBuilder, 
    route: ActivatedRoute, 
    router: Router, 
    titleService: TitleService,
    notificationService: NotificationService,
    pageStateManager: PageStateManagerService,
    authService: AuthService,
  ) {
    super(
      invoiceItemService, 
      fb, 
      route, 
      router, 
      titleService, 
      notificationService,
      pageStateManager,
      authService
    );       
  }

  override ngOnInit(): void {
    this.columns = [
      { 
        name: 'name', 
        label: 'Plot Number', 
        inputType: 'text',
        validators: [Validators.required],
        errorMessages: { required: 'Plot Number is required' },
      },
      { 
        name: 'amount', 
        label: 'Amount', 
        inputType: 'currency',
        validators: [Validators.required],
        errorMessages: { required: 'Amount is required' },
      },
      { 
        name: 'share', 
        label: 'Share', 
        inputType: 'percentage',
        validators: [
          Validators.required, 
          Validators.min(0), 
          Validators.max(1)
        ],
        errorMessages: { 
          required: 'Share is required',
          min: 'Share must be at least 0',
          max: 'Share must be at most 1', 
        },
      },
    ];
    this.route.paramMap.subscribe(params => {        
      this.parentID = parseInt(params.get('invoiceId')!);        
    }); 
    super.ngOnInit();
  }

  override onCreate(item: InvoiceItem): void {
    if (!this.parentID) {
      console.error('Parent ID not set');
      return;
    }
    item.invoiceId = this.parentID;
    super.onCreate(item);
  }

  protected override buildResultSet$(): Observable<ResultSet<InvoiceItem>> {    
      return combineLatest([
            this.currentPageSubject,
            this.pageSizeSubject
          ]).pipe(          
            switchMap(([page, size]) => {
              if(!this.parentID) {
                console.error('Parent ID not set');
                return EMPTY
              }
              const offset = (page - 1) * size;            
              return this.invoiceItemService.getItemsByInvoiceId(this.parentID, offset, size);
            })
          );
    }

}
